module.exports = __webpack_public_path__ + "static/media/GlacialIndifference-Regular.578cf3b3.woff2";